export default "__VITE_ASSET__CKg2QjdK__"